module.exports = __webpack_public_path__ + "static/img/bg-cases-banner.18f383a3.png";